import React, { useContext, useEffect, useState, Children } from "react";
import { Box, Typography, Card, CardContent, Grid, Tooltip, CircularProgress } from "@mui/material";
import { FormattedMessage } from "react-intl";
import APIContext from "../../../services/api/api";
import { URLS } from "../../../configuration/urls";
import { onShowToast } from "../../../components/toast";
import { formatNumberShort } from "../../../components/formatter";

const empty = [
  { volumeHandled: null },
  { volumeHandled: null },
  { volumeHandled: null },
  { volumeHandled: null },
  { volumeHandled: null },
  { volumeHandled: null },
  { volumeHandled: null }
];

export function MAWBVolumeHandled({ id }) {
  const [data, setData] = useState(empty);
  const { getData } = useContext(APIContext);
  const [isLoading, setIsLoading] = useState(false);
  const { showToast } = onShowToast();

  useEffect(() => {
    async function fetchVolume() {
      setIsLoading(true);
      try {
        const res = await getData(
          `h7/kpi/mawb/${id}/parcels-volume-handled`,
          {},
          URLS.EC_CLEAR_CUSTOMS_BE()
        );
        !Array.isArray(res) || res?.length === 0 ? setData(empty) : setData(res);
      } catch (err) {
        showToast({
          message: err,
          type: "error"
        });
      } finally {
        setIsLoading(false);
      }
    }

    fetchVolume();
  }, [id]);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" py={6}>
        <CircularProgress size={30} />
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ overflowX: "auto", width: "100%" }}>
        <Box
          sx={{
            flexWrap: "wrap",
            pb: 2,
            display: "flex",
            gap: "1rem",
            justifyContent: "space-around",
            alignItems: "center"
          }}
        >
          {Children.toArray(
            data?.map?.((item, index) => {
              return (
                <Card
                  sx={{
                    backgroundColor: "var(--container-dark)",
                    color: "var(--text-primary)",
                    borderRadius: "1rem",
                    boxShadow: "none",
                    flex: 1
                  }}
                  data-testid={`mawb-volume-handled-${index}`}
                >
                  <CardContent
                    sx={{
                      justifyContent: "space-between",
                      display: "flex",
                      flexDirection: "column",
                      p: "16px !important"
                    }}>
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      data-testid={`mawb_volume_handled_${index}_heading`}
                      sx={{
                        fontSize: "16px",
                        color: "var(--text-primary)"
                      }}
                    >
                      <FormattedMessage id="volumeHandled" />
                    </Typography>
                    {item?.volumeHandled != null ? (
                      <Typography
                        sx={{ mt: 1 }}
                        variant="h6"
                        fontWeight={700}
                        fontSize="20px"
                        noWrap
                        data-testid={`mawb_volume_handled_${index}_value`}
                      >
                        <Tooltip
                          placement="right"
                          title={item?.volumeHandled?.toLocaleString?.("de-DE", {
                            minimumFractionDigits: 2
                          })}>
                          {formatNumberShort(item?.volumeHandled)} kg
                        </Tooltip>
                      </Typography>
                    ) : (
                      <Typography
                        sx={{ mt: 1 }}
                        noWrap
                        data-testid={`mawb_volume_handled_${index}_nodata`}
                      >
                        <FormattedMessage id="noData" />
                      </Typography>
                    )}

                  </CardContent>
                </Card>
              );
            })
          )}
        </Box>
      </Box>
    </>
  );
}
